export enum InventoryFilters {
    display = 'display',
    date = 'date',
    aggregate = 'aggregate',
    verification = 'verification',
}
